// Generated by scripts/write-carnival-of-sins-replay-fixtures.ts.
// Do not edit manually.

import type { CarnivalOfSinsReplayEventType } from "./event-adapter";

export interface CarnivalOfSinsReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface CarnivalOfSinsReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: CarnivalOfSinsReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface CarnivalOfSinsReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "carnival-of-sins";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly CarnivalOfSinsReplayFixturePlayer[];
  readonly events: readonly CarnivalOfSinsReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const CARNIVAL_OF_SINS_REPLAY_FIXTURES: Record<
  string,
  CarnivalOfSinsReplayFixture
> = {
  "heuristic-2p": {
    schemaVersion: 1,
    gameType: "carnival-of-sins",
    scenario: "heuristic-2p",
    source: "generated",
    capturedAt: "2026-07-29T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "Mina",
        role: "host",
      },
      {
        id: "p2",
        name: "Leo",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p2",
        payload: {
          state: {
            gameId: "heuristic-2p",
            gameSeed: "heuristic-2p",
            rngState: {
              algorithm: "mulberry32",
              state: 1015537846,
            },
            phase: "SECRET_SELECT",
            round: 1,
            players: [
              {
                playerId: "p1",
                name: "Mina",
              },
              {
                playerId: "p2",
                name: "Leo",
              },
            ],
            seatingOrder: ["p1", "p2"],
            devilCardHolderId: "p2",
            revealOrder: ["p2", "p1"],
            nextToRevealIndex: 0,
            dice: [
              {
                id: "d4",
                color: "black",
                value: 1,
                position: {
                  angle: 5.150481437242551,
                  radius: 0.540350325324107,
                },
                lockedBy: null,
              },
              {
                id: "d6",
                color: "black",
                value: 4,
                position: {
                  angle: 0.6098740484563808,
                  radius: 0.5869923553080298,
                },
                lockedBy: null,
              },
              {
                id: "d8",
                color: "black",
                value: 3,
                position: {
                  angle: 5.035529594591185,
                  radius: 0.3265740845235996,
                },
                lockedBy: null,
              },
              {
                id: "d10",
                color: "black",
                value: 3,
                position: {
                  angle: 1.3928782400438655,
                  radius: 0.3364098280551843,
                },
                lockedBy: null,
              },
              {
                id: "d12",
                color: "black",
                value: 3,
                position: {
                  angle: 3.6874353804388993,
                  radius: 0.41330157619668173,
                },
                lockedBy: null,
              },
              {
                id: "d20",
                color: "black",
                value: 6,
                position: {
                  angle: 3.372014912630347,
                  radius: 0.3100684175849892,
                },
                lockedBy: null,
              },
              {
                id: "white",
                color: "white",
                value: 3,
                position: {
                  angle: 0.8046914181475213,
                  radius: 0.06531368321739138,
                },
                lockedBy: null,
              },
            ],
            handsByPlayerId: {
              p1: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p2: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
            },
            selectionsByPlayerId: {
              p1: null,
              p2: null,
            },
            revealedThisRound: [],
            scoreHistoryByPlayerId: {
              p1: [],
              p2: [],
            },
            lastRoundSummary: null,
            winnerIds: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "greed",
            dieIds: ["d8", "d10"],
          },
        },
      },
      {
        sequenceNumber: 5,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 6,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 7,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 8,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "gluttony",
            dieId: "d12",
          },
        },
      },
      {
        sequenceNumber: 9,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "gluttony",
            dieId: "d8",
          },
        },
      },
      {
        sequenceNumber: 10,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 11,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 12,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 13,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 14,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 15,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 16,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d4",
              },
              {
                dieId: "d8",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 17,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d6",
              },
              {
                dieId: "d8",
                stolenFromPlayerId: "p2",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 18,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 19,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 20,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 21,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 22,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 23,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 24,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 25,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 26,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 27,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 28,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 29,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "sloth",
          },
        },
      },
    ],
    notes: [
      "이 게임은 숨김정보가 거의 없다 — 주사위/공개된 Sin/손패 장수/점수 기록은 전부 공개. 유일하게 가려지는 것은 이번 라운드에 아직 공개하지 않은 선택의 내용.",
      "공정 휴리스틱(no-oracle): 봇은 매 행동마다 filterStateForViewer로 얻은 뷰만 사용. 손패의 첫 남은 Sin을 선택하고, 공개 시점에는 그 라운드 테이블 상태에서 규칙상 가능한 선택지를 그대로 취한다(가능하면 항상 무언가를 가져간다).",
      "결과: 7라운드 종료 · 최종 점수 [Mina 54, Leo 57] · 승자 Leo.",
    ],
  },
  "heuristic-4p": {
    schemaVersion: 1,
    gameType: "carnival-of-sins",
    scenario: "heuristic-4p",
    source: "generated",
    capturedAt: "2026-07-24T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "Nina",
        role: "host",
      },
      {
        id: "p2",
        name: "Pablo",
        role: "player",
      },
      {
        id: "p3",
        name: "Vero",
        role: "player",
      },
      {
        id: "p4",
        name: "Juan",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p2",
        payload: {
          state: {
            gameId: "heuristic-4p",
            gameSeed: "heuristic-4p",
            rngState: {
              algorithm: "mulberry32",
              state: 1083634060,
            },
            phase: "SECRET_SELECT",
            round: 1,
            players: [
              {
                playerId: "p1",
                name: "Nina",
              },
              {
                playerId: "p2",
                name: "Pablo",
              },
              {
                playerId: "p3",
                name: "Vero",
              },
              {
                playerId: "p4",
                name: "Juan",
              },
            ],
            seatingOrder: ["p1", "p2", "p3", "p4"],
            devilCardHolderId: "p2",
            revealOrder: ["p2", "p3", "p4", "p1"],
            nextToRevealIndex: 0,
            dice: [
              {
                id: "d4",
                color: "black",
                value: 1,
                position: {
                  angle: 2.2814813942748655,
                  radius: 0.08590531653026119,
                },
                lockedBy: null,
              },
              {
                id: "d6",
                color: "black",
                value: 1,
                position: {
                  angle: 4.339328308475989,
                  radius: 0.5115273609175347,
                },
                lockedBy: null,
              },
              {
                id: "d8",
                color: "black",
                value: 4,
                position: {
                  angle: 4.153452102443061,
                  radius: 0.4978950757416897,
                },
                lockedBy: null,
              },
              {
                id: "d10",
                color: "black",
                value: 7,
                position: {
                  angle: 3.716459024133014,
                  radius: 0.058378953847568485,
                },
                lockedBy: null,
              },
              {
                id: "d12",
                color: "black",
                value: 11,
                position: {
                  angle: 2.3311562976282665,
                  radius: 0.1411501111695543,
                },
                lockedBy: null,
              },
              {
                id: "d20",
                color: "black",
                value: 6,
                position: {
                  angle: 4.958857430464937,
                  radius: 0.5515769604942762,
                },
                lockedBy: null,
              },
              {
                id: "white",
                color: "white",
                value: 4,
                position: {
                  angle: 5.765541414719406,
                  radius: 0.39553619557991626,
                },
                lockedBy: null,
              },
            ],
            handsByPlayerId: {
              p1: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p2: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p3: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p4: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
            },
            selectionsByPlayerId: {
              p1: null,
              p2: null,
              p3: null,
              p4: null,
            },
            revealedThisRound: [],
            scoreHistoryByPlayerId: {
              p1: [],
              p2: [],
              p3: [],
              p4: [],
            },
            lastRoundSummary: null,
            winnerIds: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 5,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 6,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "greed",
            dieIds: ["d4", "d6"],
          },
        },
      },
      {
        sequenceNumber: 7,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 8,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 9,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 10,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 11,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 12,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 13,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 14,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "gluttony",
            dieId: "d20",
          },
        },
      },
      {
        sequenceNumber: 15,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "gluttony",
            dieId: "d8",
          },
        },
      },
      {
        sequenceNumber: 16,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "gluttony",
            dieId: "d12",
          },
        },
      },
      {
        sequenceNumber: 17,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "gluttony",
            dieId: "d6",
          },
        },
      },
      {
        sequenceNumber: 18,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 19,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 20,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 21,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 22,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 23,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 24,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 25,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 26,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 27,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 28,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 29,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 30,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d4",
              },
              {
                dieId: "d6",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 31,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d8",
              },
              {
                dieId: "d4",
                stolenFromPlayerId: "p3",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 32,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d10",
              },
              {
                dieId: "d6",
                stolenFromPlayerId: "p3",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 33,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d12",
              },
              {
                dieId: "d4",
                stolenFromPlayerId: "p4",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 34,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 35,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 36,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 37,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 38,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 39,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 40,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 41,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 42,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 43,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 44,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 45,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 46,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 47,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 48,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 49,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 50,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 51,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 52,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 53,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 54,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 55,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 56,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 57,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "sloth",
          },
        },
      },
    ],
    notes: [
      "이 게임은 숨김정보가 거의 없다 — 주사위/공개된 Sin/손패 장수/점수 기록은 전부 공개. 유일하게 가려지는 것은 이번 라운드에 아직 공개하지 않은 선택의 내용.",
      "공정 휴리스틱(no-oracle): 봇은 매 행동마다 filterStateForViewer로 얻은 뷰만 사용. 손패의 첫 남은 Sin을 선택하고, 공개 시점에는 그 라운드 테이블 상태에서 규칙상 가능한 선택지를 그대로 취한다(가능하면 항상 무언가를 가져간다).",
      "결과: 7라운드 종료 · 최종 점수 [Nina 56, Pablo 37, Vero 35, Juan 50] · 승자 Nina.",
    ],
  },
  "heuristic-5p": {
    schemaVersion: 1,
    gameType: "carnival-of-sins",
    scenario: "heuristic-5p",
    source: "generated",
    capturedAt: "2026-07-29T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "Nina",
        role: "host",
      },
      {
        id: "p2",
        name: "Pablo",
        role: "player",
      },
      {
        id: "p3",
        name: "Vero",
        role: "player",
      },
      {
        id: "p4",
        name: "Juan",
        role: "player",
      },
      {
        id: "p5",
        name: "Amara",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p2",
        payload: {
          state: {
            gameId: "heuristic-5p",
            gameSeed: "heuristic-5p",
            rngState: {
              algorithm: "mulberry32",
              state: 1184446869,
            },
            phase: "SECRET_SELECT",
            round: 1,
            players: [
              {
                playerId: "p1",
                name: "Nina",
              },
              {
                playerId: "p2",
                name: "Pablo",
              },
              {
                playerId: "p3",
                name: "Vero",
              },
              {
                playerId: "p4",
                name: "Juan",
              },
              {
                playerId: "p5",
                name: "Amara",
              },
            ],
            seatingOrder: ["p1", "p2", "p3", "p4", "p5"],
            devilCardHolderId: "p2",
            revealOrder: ["p2", "p3", "p4", "p5", "p1"],
            nextToRevealIndex: 0,
            dice: [
              {
                id: "d4",
                color: "black",
                value: 3,
                position: {
                  angle: 1.8722820434679883,
                  radius: 0.5349547147518025,
                },
                lockedBy: null,
              },
              {
                id: "d6",
                color: "black",
                value: 2,
                position: {
                  angle: 3.3954082044948515,
                  radius: 0.47641484858468175,
                },
                lockedBy: null,
              },
              {
                id: "d8",
                color: "black",
                value: 6,
                position: {
                  angle: 4.936903835781027,
                  radius: 0.6208793513360433,
                },
                lockedBy: null,
              },
              {
                id: "d10",
                color: "black",
                value: 4,
                position: {
                  angle: 5.487029205567973,
                  radius: 0.1042994927149266,
                },
                lockedBy: null,
              },
              {
                id: "d12",
                color: "black",
                value: 6,
                position: {
                  angle: 3.053346643800703,
                  radius: 0.3961633966304362,
                },
                lockedBy: null,
              },
              {
                id: "d20",
                color: "black",
                value: 8,
                position: {
                  angle: 5.1234402918531625,
                  radius: 0.5288753474014811,
                },
                lockedBy: null,
              },
              {
                id: "white",
                color: "white",
                value: 4,
                position: {
                  angle: 4.820138932922711,
                  radius: 0.541689985524863,
                },
                lockedBy: null,
              },
            ],
            handsByPlayerId: {
              p1: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p2: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p3: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p4: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
              p5: [
                "greed",
                "gluttony",
                "envy",
                "lust",
                "pride",
                "wrath",
                "sloth",
              ],
            },
            selectionsByPlayerId: {
              p1: null,
              p2: null,
              p3: null,
              p4: null,
              p5: null,
            },
            revealedThisRound: [],
            scoreHistoryByPlayerId: {
              p1: [],
              p2: [],
              p3: [],
              p4: [],
              p5: [],
            },
            lastRoundSummary: null,
            winnerIds: null,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 4,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 5,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 6,
        eventType: "SelectSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          sin: "greed",
        },
      },
      {
        sequenceNumber: 7,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "greed",
            dieIds: ["d8", "d12"],
          },
        },
      },
      {
        sequenceNumber: 8,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 9,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 10,
        eventType: "RevealSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 11,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "greed",
            dieIds: null,
          },
        },
      },
      {
        sequenceNumber: 12,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 13,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 14,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 15,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 16,
        eventType: "SelectSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          sin: "gluttony",
        },
      },
      {
        sequenceNumber: 17,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "gluttony",
            dieId: "d20",
          },
        },
      },
      {
        sequenceNumber: 18,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "gluttony",
            dieId: "d12",
          },
        },
      },
      {
        sequenceNumber: 19,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "gluttony",
            dieId: "d6",
          },
        },
      },
      {
        sequenceNumber: 20,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "gluttony",
            dieId: "d10",
          },
        },
      },
      {
        sequenceNumber: 21,
        eventType: "RevealSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          choice: {
            sin: "gluttony",
            dieId: "d4",
          },
        },
      },
      {
        sequenceNumber: 22,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 23,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 24,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 25,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 26,
        eventType: "SelectSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          sin: "envy",
        },
      },
      {
        sequenceNumber: 27,
        eventType: "RevealSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 28,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 29,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 30,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 31,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "envy",
          },
        },
      },
      {
        sequenceNumber: 32,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 33,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 34,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 35,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 36,
        eventType: "SelectSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          sin: "lust",
        },
      },
      {
        sequenceNumber: 37,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d4",
              },
              {
                dieId: "d6",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 38,
        eventType: "RevealSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d8",
              },
              {
                dieId: "d4",
                stolenFromPlayerId: "p4",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 39,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d10",
              },
              {
                dieId: "d6",
                stolenFromPlayerId: "p4",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 40,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d12",
              },
              {
                dieId: "d6",
                stolenFromPlayerId: "p1",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 41,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "lust",
            picks: [
              {
                dieId: "d20",
              },
              {
                dieId: "d4",
                stolenFromPlayerId: "p5",
              },
            ],
          },
        },
      },
      {
        sequenceNumber: 42,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 43,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 44,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 45,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 46,
        eventType: "SelectSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          sin: "pride",
        },
      },
      {
        sequenceNumber: 47,
        eventType: "RevealSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 48,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 49,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 50,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 51,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "pride",
          },
        },
      },
      {
        sequenceNumber: 52,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 53,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 54,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 55,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 56,
        eventType: "SelectSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          sin: "wrath",
        },
      },
      {
        sequenceNumber: 57,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 58,
        eventType: "RevealSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 59,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 60,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 61,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "wrath",
            target: {
              dieId: "d4",
            },
          },
        },
      },
      {
        sequenceNumber: 62,
        eventType: "SelectSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 63,
        eventType: "SelectSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 64,
        eventType: "SelectSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 65,
        eventType: "SelectSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 66,
        eventType: "SelectSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          sin: "sloth",
        },
      },
      {
        sequenceNumber: 67,
        eventType: "RevealSin",
        userId: "p3",
        payload: {
          playerId: "p3",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 68,
        eventType: "RevealSin",
        userId: "p4",
        payload: {
          playerId: "p4",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 69,
        eventType: "RevealSin",
        userId: "p5",
        payload: {
          playerId: "p5",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 70,
        eventType: "RevealSin",
        userId: "p1",
        payload: {
          playerId: "p1",
          choice: {
            sin: "sloth",
          },
        },
      },
      {
        sequenceNumber: 71,
        eventType: "RevealSin",
        userId: "p2",
        payload: {
          playerId: "p2",
          choice: {
            sin: "sloth",
          },
        },
      },
    ],
    notes: [
      "이 게임은 숨김정보가 거의 없다 — 주사위/공개된 Sin/손패 장수/점수 기록은 전부 공개. 유일하게 가려지는 것은 이번 라운드에 아직 공개하지 않은 선택의 내용.",
      "공정 휴리스틱(no-oracle): 봇은 매 행동마다 filterStateForViewer로 얻은 뷰만 사용. 손패의 첫 남은 Sin을 선택하고, 공개 시점에는 그 라운드 테이블 상태에서 규칙상 가능한 선택지를 그대로 취한다(가능하면 항상 무언가를 가져간다).",
      "결과: 7라운드 종료 · 최종 점수 [Nina 43, Pablo 41, Vero 65, Juan 32, Amara 29] · 승자 Vero.",
    ],
  },
};
